export default [
  {
    path: '/call-centre/log-watch-number',
    name: 'pageLogWatchNumberList',
    meta: { title: 'page.pageLogWatchNumberList', roles: ['CC_LOG_PHONE_VIEW'] },
    component: () => import('@/pages/call-centre/log-watch-number'),
  },
]
